import { render } from "./alconPage.vue?vue&type=template&id=55265e24&scoped=true&ts=true"
import script from "./alconPage.vue?vue&type=script&lang=ts"
export * from "./alconPage.vue?vue&type=script&lang=ts"

import "./alconPage.vue?vue&type=style&index=0&id=55265e24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55265e24"]])

export default __exports__